import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthService from "../../services/auth.service";

export const authLogin = createAsyncThunk(
  "auth/authLogin",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.login(item);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const sendotp = createAsyncThunk(
  "auth/sendotp",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.sendotp(item);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const verifyotp = createAsyncThunk(
  "auth/verifyotp",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.verifyotp(item);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);




export const sendChangeMobileOtp = createAsyncThunk(
  "auth/sendChangeMobileOtp",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.sendotp(item);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to send mobile OTP"
      );
    }
  }
);

export const verifyChangeMobileOtp = createAsyncThunk(
  "auth/verifyChangeMobileOtp",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.verifyotp(item);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to verify mobile OTP"
      );
    }
  }
);



export const sendChangeEmailOtp = createAsyncThunk(
  "auth/sendChangeEmailOtp",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.sendemailotp(item);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to send email OTP"
      );
    }
  }
);

export const verifyChangeEmailOtp = createAsyncThunk(
  "auth/verifyChangeEmailOtp",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.verifyemailotp(item);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to verify email OTP"
      );
    }
  }
);



export const userLogin = createAsyncThunk(
  "auth/userLogin",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.userLogin(item);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const userLoginVerifyOtp = createAsyncThunk(
  "auth/userLoginVerifyOtp",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.userloginVerifyOtp(item);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =========================================================
   LOGOUT
========================================================= */

export const logout = createAsyncThunk(
  "auth/logout",
  async () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("authUser");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    sessionStorage.clear();

    return true;
  }
);

/* =========================================================
   FORGOT PASSWORD
========================================================= */

export const forgotPasswords = createAsyncThunk(
  "auth/forgotPasswords",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.forgotPassword(item);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =========================================================
   VERIFICATION
========================================================= */

export const createVerification = createAsyncThunk(
  "auth/createVerification",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.createVerification(item);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const userVerifyOtp = createAsyncThunk(
  "auth/userVerifyOtp",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.userVerifyOtp(item);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =========================================================
   ROLES
========================================================= */

export const getRoles = createAsyncThunk(
  "auth/getRoles",
  async (_, thunkAPI) => {
    try {
      const response = await AuthService.getRoles();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =========================================================
   PROFILE
========================================================= */

export const getProfile = createAsyncThunk(
  "auth/getProfile",
  async (_, thunkAPI) => {
    try {
      const response = await AuthService.getProfile();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const getuserProfile = createAsyncThunk(
  "auth/getuserProfile",
  async (_, thunkAPI) => {
    try {
      const response = await AuthService.getProfile();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =========================================================
   CHANGE PASSWORD
========================================================= */

export const changePassword = createAsyncThunk(
  "auth/changePassword",
  async (item, thunkAPI) => {
    try {
      const response = await AuthService.changePassword(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =========================================================
   CLICK TO CALL
========================================================= */

export const clicktoCall = createAsyncThunk(
  "auth/clicktoCall",
  async (item, thunkAPI) => {
    try {
      const response = await AuthService.clicktoCall(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =========================================================
   INITIAL STATE
========================================================= */

const user = AuthService.getUserDetails();

const initialState = {
  loading: false,
  error: "",
  authdata: [],
  verificationData: null,

  user: user || null,

  isAuthenticated: !!user,

  /* Change contact states */
  changeMobileLoading: false,
  changeEmailLoading: false,

  changeMobileError: null,
  changeEmailError: null,
};

/* =========================================================
   SLICE
========================================================= */

const authSlice = createSlice({
  name: "auth",

  initialState,

  reducers: {},

  extraReducers: (builder) => {
    builder

      /* =====================================================
         LOGIN
      ===================================================== */

      .addCase(authLogin.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.user = null;
      })

      .addCase(authLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.isAuthenticated = true;
      })

      .addCase(authLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* =====================================================
         CREATE VERIFICATION
      ===================================================== */

      .addCase(createVerification.pending, (state) => {
        state.loading = true;
        state.error = "";
      })

      .addCase(createVerification.fulfilled, (state, action) => {
        state.loading = false;
        state.verificationData = action.payload;
      })

      .addCase(createVerification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* =====================================================
         USER LOGIN
      ===================================================== */

      .addCase(userLogin.pending, (state) => {
        state.loading = true;
        state.error = "";
      })

      .addCase(userLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.isAuthenticated = true;
      })

      .addCase(userLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.user = null;
        state.isAuthenticated = false;
      })

      /* =====================================================
         CHANGE MOBILE OTP
      ===================================================== */

      .addCase(sendChangeMobileOtp.pending, (state) => {
        state.changeMobileLoading = true;
        state.changeMobileError = null;
      })

      .addCase(sendChangeMobileOtp.fulfilled, (state) => {
        state.changeMobileLoading = false;
      })

      .addCase(sendChangeMobileOtp.rejected, (state, action) => {
        state.changeMobileLoading = false;
        state.changeMobileError = action.payload;
      })

      .addCase(verifyChangeMobileOtp.pending, (state) => {
        state.changeMobileLoading = true;
        state.changeMobileError = null;
      })

      .addCase(verifyChangeMobileOtp.fulfilled, (state) => {
        state.changeMobileLoading = false;
      })

      .addCase(verifyChangeMobileOtp.rejected, (state, action) => {
        state.changeMobileLoading = false;
        state.changeMobileError = action.payload;
      })

      /* =====================================================
         CHANGE EMAIL OTP
      ===================================================== */

      .addCase(sendChangeEmailOtp.pending, (state) => {
        state.changeEmailLoading = true;
        state.changeEmailError = null;
      })

      .addCase(sendChangeEmailOtp.fulfilled, (state) => {
        state.changeEmailLoading = false;
      })

      .addCase(sendChangeEmailOtp.rejected, (state, action) => {
        state.changeEmailLoading = false;
        state.changeEmailError = action.payload;
      })

      .addCase(verifyChangeEmailOtp.pending, (state) => {
        state.changeEmailLoading = true;
        state.changeEmailError = null;
      })

      .addCase(verifyChangeEmailOtp.fulfilled, (state) => {
        state.changeEmailLoading = false;
      })

      .addCase(verifyChangeEmailOtp.rejected, (state, action) => {
        state.changeEmailLoading = false;
        state.changeEmailError = action.payload;
      })

      /* =====================================================
         LOGOUT
      ===================================================== */

      .addCase(logout.pending, (state) => {
        state.loading = true;
        state.error = "";
      })

      .addCase(logout.fulfilled, (state) => {
        state.loading = false;
        state.error = "";
        state.user = null;
        state.isAuthenticated = false;
      })

      .addCase(logout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default authSlice.reducer;